import { StyleSheet } from 'react-native-unistyles';
import type { getRelativeTimeInfo } from '@/components/Event/EventList.utils';
import Text from '@/components/UI/Text';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';
import Box from '../UI/Box';
import Icon from '../Unistyles/Icon';

export const EventListItemInfoFragment = graphql(`
  fragment EventListItemInfo on event {
    id
    title
    location
    datetime
    status
    event_clock {
      event_id
    }
    event {
      id
      title
    }
  }
`);

export default function EventListItemInfo({
  fragment,
  relativeTimeInfo,
}: {
  fragment: FragmentOf<typeof EventListItemInfoFragment> | null | undefined;
  relativeTimeInfo: ReturnType<typeof getRelativeTimeInfo> | null | undefined;
}) {
  const event = readFragment(EventListItemInfoFragment, fragment);

  return (
    <Box flex style={style.container} space="sm" pr="xl" pt="md">
      <Box flex direction="horizontal" space="sm">
        <Box flex>
          <Box direction="horizontal" space="md">
            {event?.title ? (
              <Box flex>
                <Text
                  style={style.text}
                  variant="typographySecondary"
                  numberOfLines={1}
                  flexShrink={1}
                >
                  {event.title}
                </Text>
              </Box>
            ) : null}
          </Box>

          {event?.location ? (
            <Box direction="horizontal" space="sm">
              <Icon
                size="sm"
                variant="typographySecondary"
                name="location-outline"
              />
              <Text
                style={style.text}
                variant="typographySecondary"
                numberOfLines={1}
                flexShrink={1}
              >
                {event?.location}
              </Text>
            </Box>
          ) : null}

          {event?.event?.title ? (
            <Box direction="horizontal" space="sm">
              <Icon
                size="sm"
                variant="typographySecondary"
                name="trophy-outline"
              />
              <Text
                style={style.text}
                variant="typographySecondary"
                numberOfLines={1}
                flexShrink={1}
              >
                {event.event.title}
              </Text>
            </Box>
          ) : null}
        </Box>
      </Box>
      {relativeTimeInfo ? (
        <Box direction="horizontal" space="sm">
          {relativeTimeInfo?.icon ? (
            <Icon
              variant={relativeTimeInfo.variant}
              name={relativeTimeInfo.icon}
              size="xl"
            />
          ) : null}
          <Text
            style={style.status}
            variant={relativeTimeInfo?.variant}
            size="sm"
            numberOfLines={2}
          >
            {relativeTimeInfo?.title}
          </Text>
        </Box>
      ) : null}
    </Box>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  text: {
    fontWeight: theme.fontWeight.semibold,
    minWidth: theme.size(2),
    flexShrink: 1,
    fontSize: theme.fontSize.sm,
    textAlignVertical: 'center',
  },
  status: {
    fontWeight: theme.fontWeight.semibold,
    fontSize: {
      base: theme.fontSize.md,
      lg: theme.fontSize.xl,
    },
  },
}));
